import {
  PLACE_PRODUCT_TRIGGER_GET_REQUEST,
  PLACE_PRODUCT_TRIGGER_GET_SUCCESS,
  PLACE_PRODUCT_TRIGGER_GET_FAILURE,
  PLACE_PRODUCT_TRIGGER_ADD_REQUEST,
  PLACE_PRODUCT_TRIGGER_ADD_SUCCESS,
  PLACE_PRODUCT_TRIGGER_ADD_FAILURE,
  PLACE_PRODUCT_TRIGGER_UPDATE_REQUEST,
  PLACE_PRODUCT_TRIGGER_UPDATE_SUCCESS,
  PLACE_PRODUCT_TRIGGER_UPDATE_FAILURE,
  PLACE_TRIGGER_DEFINATION_GET_REQUEST,
  PLACE_TRIGGER_DEFINATION_GET_SUCCESS,
  PLACE_TRIGGER_DEFINATION_GET_FAILURE,
  PLACE_TRIGGER_DEFINATION_ADD_REQUEST,
  PLACE_TRIGGER_DEFINATION_ADD_SUCCESS,
  PLACE_TRIGGER_DEFINATION_ADD_FAILURE,
  PLACE_TRIGGER_DEFINATION_DELETE_REQUEST,
  PLACE_TRIGGER_DEFINATION_DELETE_SUCCESS,
  PLACE_TRIGGER_DEFINATION_DELETE_FAILURE,
  PLACE_PRODUCT_DEFINATION_RULE_GET_REQUEST,
  PLACE_PRODUCT_DEFINATION_RULE_GET_SUCCESS,
  PLACE_PRODUCT_DEFINATION_RULE_GET_FAILURE,
  PLACE_PRODUCT_DEFINATION_RULE_ADD_REQUEST,
  PLACE_PRODUCT_DEFINATION_RULE_ADD_SUCCESS,
  PLACE_PRODUCT_DEFINATION_RULE_ADD_FAILURE,
  PLACE_PRODUCT_DEFINATION_RULE_UPDATE_REQUEST,
  PLACE_PRODUCT_DEFINATION_RULE_UPDATE_SUCCESS,
  PLACE_PRODUCT_DEFINATION_RULE_UPDATE_FAILURE,
  PLACE_PRODUCT_TRIGGER_LOG_GET_REQUEST,
  PLACE_PRODUCT_TRIGGER_LOG_GET_SUCCESS,
  PLACE_PRODUCT_TRIGGER_LOG_GET_FAILURE,
} from './actionTypes';
import productSyncService from '../../services/productSyncService';

const listFromResponse = (response) => response.data?.data?.data || [];

// PlaceProductTrigger
export const GetPlaceProductTrigger = (userId) => {
  return async (dispatch) => {
    dispatch({ type: PLACE_PRODUCT_TRIGGER_GET_REQUEST });
    try {
      const response = await productSyncService.getTrigger(userId);
      const list = listFromResponse(response);
      dispatch({ type: PLACE_PRODUCT_TRIGGER_GET_SUCCESS, payload: list });
      return list;
    } catch (error) {
      dispatch({ type: PLACE_PRODUCT_TRIGGER_GET_FAILURE, payload: error.response?.data });
      throw error;
    }
  };
};

export const AddPlaceProductTrigger = (data) => {
  return async (dispatch) => {
    dispatch({ type: PLACE_PRODUCT_TRIGGER_ADD_REQUEST });
    try {
      const response = await productSyncService.addTrigger(data);
      dispatch({ type: PLACE_PRODUCT_TRIGGER_ADD_SUCCESS, payload: response.data });
      return response.data;
    } catch (error) {
      dispatch({ type: PLACE_PRODUCT_TRIGGER_ADD_FAILURE, payload: error.response?.data });
      throw error;
    }
  };
};

export const UpdatePlaceProductTrigger = (data) => {
  return async (dispatch) => {
    dispatch({ type: PLACE_PRODUCT_TRIGGER_UPDATE_REQUEST });
    try {
      const response = await productSyncService.updateTrigger(data);
      dispatch({ type: PLACE_PRODUCT_TRIGGER_UPDATE_SUCCESS, payload: response.data });
      return response.data;
    } catch (error) {
      dispatch({ type: PLACE_PRODUCT_TRIGGER_UPDATE_FAILURE, payload: error.response?.data });
      throw error;
    }
  };
};

// PlaceTriggerDefination
export const GetPlaceTriggerDefinations = (triggerId) => {
  return async (dispatch) => {
    dispatch({ type: PLACE_TRIGGER_DEFINATION_GET_REQUEST });
    try {
      const response = await productSyncService.getDefinations(triggerId);
      const list = listFromResponse(response);
      dispatch({ type: PLACE_TRIGGER_DEFINATION_GET_SUCCESS, payload: list });
      return list;
    } catch (error) {
      dispatch({ type: PLACE_TRIGGER_DEFINATION_GET_FAILURE, payload: error.response?.data });
      throw error;
    }
  };
};

export const AddPlaceTriggerDefination = (data) => {
  return async (dispatch) => {
    dispatch({ type: PLACE_TRIGGER_DEFINATION_ADD_REQUEST });
    try {
      const response = await productSyncService.addDefination(data);
      dispatch({ type: PLACE_TRIGGER_DEFINATION_ADD_SUCCESS, payload: response.data });
      return response.data;
    } catch (error) {
      dispatch({ type: PLACE_TRIGGER_DEFINATION_ADD_FAILURE, payload: error.response?.data });
      throw error;
    }
  };
};

export const DeletePlaceTriggerDefination = (id) => {
  return async (dispatch) => {
    dispatch({ type: PLACE_TRIGGER_DEFINATION_DELETE_REQUEST });
    try {
      const response = await productSyncService.deleteDefination(id);
      dispatch({ type: PLACE_TRIGGER_DEFINATION_DELETE_SUCCESS, payload: response.data });
      return response.data;
    } catch (error) {
      dispatch({ type: PLACE_TRIGGER_DEFINATION_DELETE_FAILURE, payload: error.response?.data });
      throw error;
    }
  };
};

// PlaceProductDefinationRule
export const GetPlaceProductDefinationRule = (definationId) => {
  return async (dispatch) => {
    dispatch({ type: PLACE_PRODUCT_DEFINATION_RULE_GET_REQUEST });
    try {
      const response = await productSyncService.getRule(definationId);
      const list = listFromResponse(response);
      dispatch({ type: PLACE_PRODUCT_DEFINATION_RULE_GET_SUCCESS, payload: list });
      return list;
    } catch (error) {
      dispatch({ type: PLACE_PRODUCT_DEFINATION_RULE_GET_FAILURE, payload: error.response?.data });
      throw error;
    }
  };
};

export const AddPlaceProductDefinationRule = (data) => {
  return async (dispatch) => {
    dispatch({ type: PLACE_PRODUCT_DEFINATION_RULE_ADD_REQUEST });
    try {
      const response = await productSyncService.addRule(data);
      dispatch({ type: PLACE_PRODUCT_DEFINATION_RULE_ADD_SUCCESS, payload: response.data });
      return response.data;
    } catch (error) {
      dispatch({ type: PLACE_PRODUCT_DEFINATION_RULE_ADD_FAILURE, payload: error.response?.data });
      throw error;
    }
  };
};

export const UpdatePlaceProductDefinationRule = (data) => {
  return async (dispatch) => {
    dispatch({ type: PLACE_PRODUCT_DEFINATION_RULE_UPDATE_REQUEST });
    try {
      const response = await productSyncService.updateRule(data);
      dispatch({ type: PLACE_PRODUCT_DEFINATION_RULE_UPDATE_SUCCESS, payload: response.data });
      return response.data;
    } catch (error) {
      dispatch({ type: PLACE_PRODUCT_DEFINATION_RULE_UPDATE_FAILURE, payload: error.response?.data });
      throw error;
    }
  };
};

export const DeletePlaceProductDefinationRule = (id) => {
  return async () => {
    const response = await productSyncService.deleteRule(id);
    return response.data;
  };
};

// PlaceProductTriggerLog (salt okunur)
export const GetPlaceProductTriggerLogs = (triggerId, page, pageSize) => {
  return async (dispatch) => {
    dispatch({ type: PLACE_PRODUCT_TRIGGER_LOG_GET_REQUEST });
    try {
      const response = await productSyncService.getLogs(triggerId, page, pageSize);
      const page_data = response.data?.data || { data: [], recordsTotal: 0 };
      dispatch({ type: PLACE_PRODUCT_TRIGGER_LOG_GET_SUCCESS, payload: page_data });
      return page_data;
    } catch (error) {
      dispatch({ type: PLACE_PRODUCT_TRIGGER_LOG_GET_FAILURE, payload: error.response?.data });
      throw error;
    }
  };
};

// Birleşik dropdown lookup listeleri (ayrı action type gerekmez, salt liste döner)
export const GetPlaceOptionsList = () => {
  return async () => {
    const [marketPlaceRes, ecommercePlaceRes] = await Promise.all([
      productSyncService.getMarketPlaces(),
      productSyncService.getEcommercePlaces(),
    ]);
    const marketPlaces = listFromResponse(marketPlaceRes).map((m) => ({
      key: `mp-${m.id}`,
      id: m.id,
      name: m.name,
      sourceType: 'marketplace',
    }));
    const ecommercePlaces = listFromResponse(ecommercePlaceRes).map((e) => ({
      key: `ec-${e.id}`,
      id: e.id,
      name: e.name,
      sourceType: 'ecommerce',
    }));
    return [...marketPlaces, ...ecommercePlaces];
  };
};
